import React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import { styled } from '@mui/material/styles';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));


const BootstrapDialogTitle = (props) => {
    const { children, onClose, ...other } = props;

    return (
        <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
            {children}
            {onClose ? (
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            ) : null}
        </DialogTitle>
    );
};
export default function MuiModal({ title, button_name, openCustomerModal, setOpenCustomerModal, children }) {

    function handleClose() {
        setOpenCustomerModal(false);
    }

    return (
        <BootstrapDialog
            fullWidth={true}
            maxWidth={"lg"}
            aria-labelledby="customized-dialog-title"
            open={openCustomerModal}
            onClose={() => handleClose()} >
            <BootstrapDialogTitle id="customized-dialog-title" onClose={handleClose}>
                {title}
            </BootstrapDialogTitle>
            <DialogContent dividers sx={{ '& > :not(style)': { width: '100%' } }}>
                {children}
            </DialogContent>
            <DialogActions>
                <Button autoFocus onClick={handleClose}>
                    {button_name}
                </Button>
            </DialogActions>
        </BootstrapDialog>
    );
}
